import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n.use(initReactI18next);

// LanguageDetector relies on `window`; only enable it on the client so the
// static pre-render (SSG) build does not touch browser-only globals.
if (typeof window !== 'undefined') {
  i18n.use(LanguageDetector);
}

i18n.init({
  lng: 'en',
  fallbackLng: 'en',
  debug: false,
  resources: messages,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
